import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { environment } from '@fitness-force/environments';
import { AppErrors, ConflictError, NotFoundError } from '@fitness-force/models';
import type {
  AmendmentPreviewRequest,
  AmendmentPreviewResponse,
  ExecuteAmendmentRequest,
  ExecuteAmendmentResponse,
} from '@fitness-force/models';
import { Observable, catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionAmendmentService {
  private readonly http = inject(HttpClient);

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  amendmentPreview(
    tenantId: number,
    clientId: number,
    subscriptionId: number,
    request: AmendmentPreviewRequest,
  ): Observable<AmendmentPreviewResponse> {
    const url =
      environment.BASE_URL +
      CONST_URL_SEGEMENTS.PLAN.AMENDMENT_PREVIEW.replace(
        '{tenant_id}',
        tenantId.toString(),
      )
        .replace('{client_id}', clientId.toString())
        .replace('{subscription_id}', subscriptionId.toString());

    return this.http
      .post<AmendmentPreviewResponse>(url, request, this.httpOptions)
      .pipe(
        map((res) => res),
        catchError((error: Response) => this.handleError(error)),
      );
  }

  executeAmendment(
    tenantId: number,
    clientId: number,
    subscriptionId: number,
    request: ExecuteAmendmentRequest,
  ): Observable<ExecuteAmendmentResponse> {
    const url =
      environment.BASE_URL +
      CONST_URL_SEGEMENTS.PLAN.EXECUTE_AMENDMENT.replace(
        '{tenant_id}',
        tenantId.toString(),
      )
        .replace('{client_id}', clientId.toString())
        .replace('{subscription_id}', subscriptionId.toString());

    return this.http
      .post<ExecuteAmendmentResponse>(url, request, this.httpOptions)
      .pipe(
        map((res) => res),
        catchError((error: Response) => this.handleError(error)),
      );
  }

  private handleError(error: Response) {
    if (error.status === 404) {
      return throwError(() => new NotFoundError(error));
    }
    if (error.status === 409) {
      return throwError(() => new ConflictError(error));
    }
    return throwError(() => new AppErrors(error));
  }
}
